<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" class="scaling-svg">
      <g id="Icon_mail" transform="translate(0.483 0.038)">
        <path
          id="Shape"
          d="M15.3,12H1.7A1.709,1.709,0,0,1,0,10.285V1.714A1.709,1.709,0,0,1,1.7,0H15.3A1.709,1.709,0,0,1,17,1.714v8.571A1.709,1.709,0,0,1,15.3,12ZM1.7,2.725v6.7a.854.854,0,0,0,.85.857h11.9a.854.854,0,0,0,.85-.857v-6.7L8.5,7.011ZM3.3,1.714,8.5,4.989l5.2-3.275Z"
          transform="translate(-0.483 -0.038)"
          fill="#534d69"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DocumentsInSendOrderIcon extends Vue {}
</script>

<style>
</style>
